import * as React from 'react';
import styled, { css } from 'styled-components';

import EventProcedureStepActionButton from 'security-app/components/SecurityEvents/EventProcedures/plugin/EventProcedureStepActionButton';
import type { EventProcedureStepAPIType } from 'security-app/hooks/api/eventProceduresAPI.types';

const EventProcedureStepContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    padding: 0.5rem 1rem;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-radius: 3px;
    border: 1px solid ${theme.colors.misc.divider};
    margin: 4px 0;
    width: 100%;
  `,
);

const EventProcedureStepInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 3;
`;

type Props = {
  order: number;
  step: EventProcedureStepAPIType;
};

function EventProcedureStepView({ order, step }: Props) {
  return (
    <EventProcedureStepContainer>
      <EventProcedureStepInfo>
        <strong>{`${order}. ${step.title}`}</strong>
        <div>{step.description}</div>
      </EventProcedureStepInfo>
      <EventProcedureStepActionButton step={step} />
    </EventProcedureStepContainer>
  );
}

export default EventProcedureStepView;
